import { render, staticRenderFns } from "./CompanyListInfoItem.vue?vue&type=template&id=36f5f993&"
import script from "./CompanyListInfoItem.vue?vue&type=script&lang=js&"
export * from "./CompanyListInfoItem.vue?vue&type=script&lang=js&"
import style0 from "./CompanyListInfoItem.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports